import { WordingMultiAstrologyMeditationLove } from '@/types';

export const MULTI_ASTROLOGY_MEDITATION_LOVE_WORDING_RO: WordingMultiAstrologyMeditationLove = {
  components_header_media_content: 'Astrologie',
  components_header_media_multi_content_2: 'Meditaţie',
  components_header_media_multi_content_3: 'Dragoste',
  components_header_text1: 'Ghizi',
  components_header_text2: 'Blog',
  hero_text: 'Găsește claritate, echilibru și conexiune.',
  hero_button_text: 'Începe-ți călătoria',
  components_ressources_subheader_text: 'Sfaturi și inspirație',
  components_ressources_span_text: 'Reunește perspective astrologice personale, practici de meditație calmantă și îndrumări amoroase atente pentru a sprijini autodescoperirea, echilibrul emoțional și o conexiune mai profundă.',
  components_ressources_card_1_title: 'Sfaturi de meditație',
  components_ressources_card_1_text: 'Ghid rapid pentru o mai bună calmitate, respirație și concentrare.',
  components_ressources_card_2_title: 'Îndrumare din dragoste',
  components_ressources_card_2_text: 'Sfaturi simple pentru a construi o conexiune mai puternică și un echilibru emoțional.',
  components_ressources_link: 'Descoperă mai multe',
  components_notes_and_google_title_1: 'Găsește claritate',
  components_notes_and_google_title_2: 'Calm interior',
  components_notes_and_google_title_3: 'Conexiune cardiacă',
  media_content_section_multi_1_subheader_text: 'Podcastul nostru',
  media_content_section_multi_2_subheader_text: 'Meditațiile noastre',
  media_content_section_multi_3_subheader_text: 'Discuții reale despre romantismul cosmic',
  page_media_content_menu_antistress: 'Antistres',
  page_media_content_menu_mindfulness: 'Mindfulness',
  page_media_content_menu_energyboost: 'Impuls de energie',
  page_media_content_menu_mantra: 'Mantră',
  page_media_content_menu_foundations: 'Fundații',
  page_media_content_menu_spirituality: 'Spiritualitate',
  page_media_content_menu_tarot: 'Tarot',
  page_media_content_menu_psychology: 'Psihologie',
  page_media_content_menu_trends: 'Tendințe',
  page_media_content_menu_compatibility: 'Compatibilitate',
  page_media_content_menu_love: 'Dragoste',
  text2_section_title: 'BLOG',
  text2_section_subheader_text: 'Articole și perspective',
  text2_section_button_more: 'Încărcați mai mult',
  components_text1_section_title: 'GHIDURI',
  components_text1_subheader_text: 'Cunoaștere Cosmică pentru Aliniere Zilnică',
  components_text1_span_text: 'Aliniază-te cu ritmurile universului: explorează o colecție atent selecționată de ghiduri astrologice și meditative detaliate, concepute pentru a trezi claritatea interioară, a aprofunda conștiința de sine și a-ți susține călătoria spre o creștere celestă și plină de suflet.',
  components_text1_card_1_title: 'Deschis către liniște',
  components_text1_card_1_text: 'Începe-ți călătoria cu ghiduri fundamentale de meditație și astrologie - ideale pentru căutătorii atrași de liniștea interioară, tiparele cosmice și introspecția personală.',
  components_text1_card_3_title: 'Legătura minte-corp',
  components_text1_card_3_text: 'Descoperă straturile mai profunde ale lumii tale interioare. Aceste ghiduri depășesc suprafața pentru a dezvălui semnificația, emoția și tiparele conștiente care îți modelează experiența.',
  components_text1_card_2_title: 'Reflectă și integrează',
  components_text1_card_2_text: 'De la blocaje emoționale la cicluri planetare - aceste ghiduri oferă instrumente pentru reflecție, vindecare și transformare prin ritualuri conștiente și înțelepciune astrologică.',
  components_text1_link: 'Vezi toate ghidurile',
  components_footer_text: 'Găsește claritate, echilibrează-ți mintea și conectează-te cu sensul – locul tău pentru astrologie, meditație și iubire.',
};